import React from 'react';
import "../style/clients.css";
import c1 from "../Assets/c1.png";
import c2 from "../Assets/c2.jpeg";
import c3 from "../Assets/cs3.jpeg";
import c4 from "../Assets/cs4.jpg";
import c5 from "../Assets/cs5.png";
import { motion } from "motion/react";

const CLIENT_LOGOS = [
    { src: c1, alt: 'Client logo 1' },
    { src: c2, alt: 'Client logo 2' },
    { src: c3, alt: 'Client logo 3' },
    { src: c4, alt: 'Client logo 4' },
    { src: c5, alt: 'Client logo 5' },
];

const Clients = () => {
    return (
        <motion.section
            className="ClientsBox"
            id="clients"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.9, ease: 'easeOut' }}
        >
            <div className="clientsHeader">
                <span className="clientsEyebrow">Trusted by</span>
                <h2 className="clientsTitle">
                    <span className="clientsTitleLight">Our top</span>
                    <span className="clientsTitleBold">Clients</span>
                </h2>
                <p className="clientsSubtitle">Brands and businesses that trust us to fit out their kitchens.</p>
            </div>

            <div className="marqueeWrap">
                <div className="marqueeTrack">
                    {[...CLIENT_LOGOS, ...CLIENT_LOGOS].map((logo, i) => (
                        <div
                            className="clientChip"
                            key={`${logo.alt}-${i}`}
                            aria-hidden={i >= CLIENT_LOGOS.length ? 'true' : undefined}
                        >
                            <img className="clientLogo" src={logo.src} alt={logo.alt} loading="lazy" />
                        </div>
                    ))}
                </div>
            </div>
        </motion.section>
    );
};

export default Clients;